import React from 'react';
import ReactPlayer from 'react-player';
import c from 'classnames';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphPodcast = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);

  // The primary link (soundcloud).
  const primaryLink = entity.getIn(['field_link', 0, 'uri']);

  // Secondary links.
  const spotifyLink = entity.getIn(['field_spotify_link', 0, 'uri']);
  const appleLink = entity.getIn(['field_apple_link', 0, 'uri']);
  const googleLink = entity.getIn(['field_google_link', 0, 'uri']);

  const hasSecondaryLinks = (spotifyLink || appleLink || googleLink);

  if (!primaryLink) {
    return <></>;
  }

  const podcastClasses = c('ParagraphPodcast', {
    'ParagraphPodcast--has-secondary-links': hasSecondaryLinks,
  });

  return (
    <Container small className={podcastClasses}>
      <div className="ParagraphPodcast__inner">
        {title && (
          <div className="ParagraphPodcast__title">
            {title}
          </div>
        )}
        {body && (
          <div className="ParagraphPodcast__body">
            <WysiwygField
              property="schema:text"
              html={body}
            />
          </div>
        )}
        <ReactPlayer
          url={primaryLink}
          show_artwork="false"
          config={{
            soundcloud: {
              options: {
                auto_play: false,
                color: '#FFE37E',
                buying: false,
                sharing: true,
                download: false,
                show_artwork: false,
                show_playcount: false,
                show_user: false,
                start_track: 0,
                single_active: true,
              },
            },
          }}
          height="150px"
          width="100%"
        />
        {hasSecondaryLinks ? (
          <div className="ParagraphPodcast__secondary_links">
            {spotifyLink && <CoreLink className="ParagraphPodcast__spotify" to={spotifyLink} />}
            {appleLink && <CoreLink className="ParagraphPodcast__apple" to={appleLink} />}
            {googleLink && <CoreLink className="ParagraphPodcast__google" to={googleLink} />}
          </div>
        ) : (null)}
      </div>
    </Container>
  );
};

export default ParagraphPodcast;
